import Vue from 'vue'
import Router from 'vue-router'
import $vuex from '@/store'
import login from './login'
import tokenLogin from './token_login'
import menu from './menu'
import permissions from './permissions'
import roles from './roles'
import user from './user'
import setting from './setting'
import carousel from './carousel'
import adPosition from './ad_position'
import link from './link'
import category from './category'
import article from './article'
import live from './live'
import lecturer from './lecturer'
import statistics from './statistics'
import attachment from './attachment'
import sysLog from './sys_log'
import company from './company'
// import openapi from './openapi'
import openapiServer from './openapi_server'
import tradeRecharge from './trade_recharge'
import tradeWithdraw from './trade_withdraw'
import tradeTax from './trade_tax'
import wsAccount from './ws_account'
import settlement from './settlement'
import customer from './customer.js'
import bill from './bill.js'
import account from './account.js'
import task from './task.js'
import job from './job.js'
import review from './review.js'
import inventory from './inventory.js'
import signer from './signer.js'
import missionCenter from './mission_center.js'
import mixRecharge from './mix_recharge.js'
import mixWithdraw from './mix_withdraw.js'
import statement from './statement.js'
import monthlybill from './monthlybill.js'
import information from './information.js'
import contract from './contract.js'
import bindaccount from './bindaccount.js'
import invoicePartner from './invoice_partner.js'
import adminInvoice from './admin_invoice.js'
import invoice from './invoice.js'
import agreement from './agreement.js'
import audit from './audit.js'
import home from './home.js'
import position from './position'
import preview from './preview.js'
import treeTest from './tree_test.js'
import system from './system.js'
import announce from './announce.js'
import individual from './individual.js'
import config from '@/config/config'
import invoiceOpen from "@/router/invoiceOpen"
import yicheng from "./yicheng.js"
import declare from "./declare.js" // 申报中心
import openAccount from "./openAccount.js" // 申报开会
import everyday_statistics from "./everyday_statistics"//每日统计
import delivery from "./delivery"//每日统计
import privateTask from './privateTask'
import publicTask from './publicTask'
import anxinCode from './anxinCode'
import new_hr from './new_hr'
import scheduling from './scheduling'
let isST = true //是否需要生态页面
if (config.domain.id) {
	isST = config.domain.is_show_ecology_page ? true : false; //是否需要生态页面
} else {
	let ym = config.domain.domain;
	// ym= 'khl-cxkj.51xinlong.com'
	let ym_arr = [
		'trade.51xinlong.com',
		'khl-oem.51xinlong.com',
		'khl-yfx.51xinlong.com',
		'khl-zlr.51xinlong.com',
		'www.shuilili.com',
		'www.freeman-pay.cn',
		'saas.bthzrl.com',
		'saas.xrkcaishui.com',
		'khl-cxkj.51xinlong.com',
		'saas.ylg123.cn',
		'www.hjyifaxin.vip',
    'www.51aixinyun.com',
    'www.yunjugong.com.cn',
    'www.juyongong.com.cn',
    'www.xinnengqifu.com',
    'www.xinxinhang.cn',
    'www.lierjixin.com',
    'www.toploong.top'
	];
	ym_arr.map((item) => {
		if (item == ym) {
			isST = false
		}
	})
}

// 解决vue报错vue-router.esm.js
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

let MainIndex = {
	path: '/', //生态展示图
	component: () => import('@/pages/home/main')
}

if (isST == false) {
	MainIndex = {
		path: '/',
		redirect: '/home',
		// component: () => import('@/pages/home/Home')
	}
}



Vue.use(Router)

// 路由详情
const routes = [
	MainIndex,
	{
		path: '/login', //生态展示图
		component: () => import('@/pages/home/main')
	},
	{
		path: '/',
		component: () => import('@/layouts/BasicLayout'),
		meta: {
			title: '首页'
		},
		hidden: true,
		children: [
			home, //首页
			yicheng,
			menu, // 菜单
			permissions, // 权限
			roles, // 角色
			user, // 用户
			setting, // 基础设置
			carousel, // 轮播图
			adPosition, // 广告位
			link, // 友情链接
			category, // 分类管理
			article, // 文章管理
			live, // 直播管理
			lecturer, // 讲师管理
			statistics, // 统计管理
			attachment, // 附件管理
			sysLog, // 系统日志
			company, // 公司管理
			// openapi, // 开放平台配置管理
			openapiServer, // 开放平台配置管理
			tradeRecharge, // 充值流水管理
			tradeWithdraw, // 交易流水管理
			tradeTax, // 交易流水管理
			wsAccount, // 网商子账号
			settlement, // 银行中心->账户资料
			customer, //人才签约
			bill, //结算清单管理
			task, //任务结算
			publicTask, //公域任务发布
			...privateTask, //私域任务发布
			job, // 公域任务结算
			review, //结算审核
			account, //账号管理
			inventory, //结算单记录
			signer, //签约人员查看
			missionCenter, //任务中心
			...position, // 岗位发布
			mixRecharge, //充值记录
			mixWithdraw, //发放明细
			statement, //结算单记录
			monthlybill, //月度账单
			information, //账号信息
			contract, //绑定合同
			bindaccount, //绑定账号
			invoicePartner, //开票管理
			adminInvoice, //开票审核
			invoice, //在线开票
			audit, //各种审核
			preview, //各种预览
			treeTest, //树形结构
			system, //后台公告
			announce, //公告管理
			individual, //个体户注册
			invoiceOpen, //发票代开
			everyday_statistics,//每日统计
			...delivery,
			declare, // 申报中心
			openAccount, // 申报开户
			...anxinCode, //安心登记卡
			...new_hr, //需付费查看打卡
			...scheduling, //排班考勤
			{
				path: 'exception/404',
				component: () => import( /* webpackChunkName: "exception-404" */ '@/pages/exception/404')
			}
		]
	},

	{
		path: '/mainDetail', //生态展示图详情
		component: () => import('@/pages/home/detail')
	},
	{
		path: '/',
		component: () => import('@/layouts/PassportLayout'),
		children: [
			login, // 登录
			tokenLogin, // /token_login?t=xxx 令牌登录
		]
	},
	{
		path: '/',
		component: () => import('@/layouts/ContractLayout'),
		children: [
			agreement, // 合同
		]
	},
	{
		path: "*",
		redirect: '/exception/404',
		// component: () => import('@/pages/exception/404')
	}
]

// 实例化
const router = new Router({
	base: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/',
	mode: 'history',
	routes
})

// 路由钩子
router.beforeEach((to, from, next) => {
	ifLogin(to, next)
	handelSiderMenu(to)
	next()
});

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 */
let handelSiderMenu = (to) => {
	$vuex.commit('handleRoutePath', to.path)
}

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 * @param {*} next 回调函数
 */
let ifLogin = (to, next) => {
	let userInfo = JSON.parse(localStorage.getItem('user_info'))
	// 是生态页面
	let isMain = to.path === '/'
	let isMain2 = to.path === '/login'
	let isDetail = to.path.indexOf('/mainDetail') != -1
	let isTokenLogin = to.path.indexOf('tLogin') != -1

	console.log(to.path, '当前页面')
	// 判断是否是登录页
	let idx = to.path.indexOf('loginIndex') != -1

	if (isST == false) {
		if (!userInfo && !idx && !isTokenLogin) {
			next('/loginIndex')
		}
	} else {
		// 没有userInfo 且 不是login 页 => 登录页
		if (!userInfo && !idx && !isMain && !isDetail && !isMain2 && !isTokenLogin) {
			next('/loginIndex')
		}
	}

	// 有userinfo 且 是login 页 => 首页
	if (idx && userInfo) {
		next('/home')
	}

}

export default router
